<template>
  <div>
    <button class="gsd-btn gsd-btn-tertiary" @click="openProductModal">Voeg product toe</button>

    <Modal :open="productModal" @close="productModal = false">
      <template v-slot:modal-content>
        <div class="add-product-modal">
          <div class="modal-title">
            <h3>Voeg een product toe</h3>
            <a @click="closeProductModal" class="gsd-modal-close">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor"/>
                <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)"
                      fill="currentColor"/>
                <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)"
                      fill="currentColor"/>
              </svg>
            </a>
          </div>
          <div class="modal-content">
            <input type="text" v-model="searchProduct" @input="onInputChange" name="search" id="productsearch"
                   placeholder="Zoek uw product..." autocomplete="off"/>
            <TheLoader class="loader" v-if="loading"></TheLoader>
            <div v-else-if="foundProducts.length > 0">
              <table class="product-table">
                <thead>
                <tr class="dataTableHeadingRow">
                  <td>Productcode</td>
                  <td>Productnaam</td>
                  <td></td>
                </tr>
                </thead>
                <tbody>
                <tr class="product-row" v-for="product in foundProducts" :key="product.id">
                  <td>{{ product.code }}</td>
                  <td class="product-option-cel">
                    <p>{{ product.content?.title }}</p>
                    <div v-if="product.options">
                      <select style="width: 200px; padding: 3px" v-model="selectedOptions[product.id]">
                        <option :key="key" :value="{key: key, label: label } " v-for="(label, key) in product.options">
                          {{ label }}
                        </option>
                      </select>
                    </div>
                  </td>
                  <td>
                    <div>
                      <button class="btn-add" @click="addAdminProduct(product)">
                        <svg xmlns="http://www.w3.org/2000/svg" height="0.8em" width="0.8em" viewBox="0 0 448 512">
                          <path
                              d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/>
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <p v-else class="search-message">{{ searchMessage }}</p>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script setup>
import {ref} from 'vue';
import axios from 'axios';
import Modal from './general/Modal.vue';
import TheLoader from "../components/general/TheLoader.vue";

const productModal = ref(false);
const searchProduct = ref('');
const foundProducts = ref([]);
const selectedOptions = ref({});
const loading = ref(false);
const searchMessage = ref('Voer een zoekterm in om producten op te halen');
let debounceTimer = null;

const sessionLang = document.documentElement.lang || 'nl';
const emit = defineEmits(['product-selected'])

function openProductModal() {
  productModal.value = true;
  document.body.style.overflow = 'hidden';
}

function closeProductModal() {
  searchProduct.value = "";
  foundProducts.value = [];
  productModal.value = false;
  document.body.style.overflow = 'auto';
}

function onInputChange() {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(() => {
    searchProducts();
  }, 750);
  if (searchProduct.value === '') {
    searchMessage.value = 'Voer een zoekterm in om producten op te halen';
  }
}

async function searchProducts() {
  foundProducts.value = [];
  if (searchProduct.value === "") return;

  loading.value = true;
  try {
    const response = await axios.post(`/${sessionLang}/api/productsearchgo`, {
      search: searchProduct.value
    });

    if (response.status === 200) {
      foundProducts.value = response.data.data;
      if (foundProducts.value.length === 0) {
        searchMessage.value = 'Geen producten gevonden.';
      }
    }

  } catch (error) {
    console.error("Search error:", error);
    alert("Er is een fout opgetreden bij het zoeken.");
  } finally {
    loading.value = false;
  }
}

function addAdminProduct(product) {
  let selectedOption = selectedOptions.value[product.id];
  if (selectedOption) {
    product.options = {
      value: selectedOption.key,
      type: "TEAMCOLOR"
    };
  }
  product.product_id = product.id;
  emit('product-selected', product);
  productModal.value = false;
  document.body.style.overflow = 'auto';
}
</script>

<style>
.add-product-modal {
  background-color: white;
  border-radius: 10px;
  width: 600px;
  max-width: 90vw;
  height: 600px;
}

#productsearch {
  margin-bottom: 20px;
}

#product-loader {
  width: 300px;
}

.add-product-modal .modal-title {
  background-color: var(--brown);
  color: white;
  padding: 20px;
  border-radius: 10px 10px 0 0;
  display: flex;
  width: 100%;
  justify-content: space-between
}

.add-product-modal .modal-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 80%;
  text-align: center;
}

.modal-content > div {
  height: 400px;
  width: 100%;
  overflow-y: auto;
}

.product-table {
  border-collapse: collapse;
  width: 100%;
}

.product-table thead {
  position: sticky;
  top: 0;
}

.product-table tbody {
  max-height: 300px;
  overflow-y: auto;
}

.product-table tbody .product-row {
  height: 30px;
}

.product-table tbody .product-row .product-option-cel {
  display: flex;
  justify-content: space-between;
  align-items: center
}

.product-table tr td {
  padding: 10px;
}

.product-table tr td button {
  background-color: transparent;
  border: none;
}

.product-table tr td button:hover {
  cursor: pointer;
  transform: scale(1.5);
  fill: var(--orange);
}

.product-table thead {
  background-color: var(--light-brown);
  font-weight: bold;
}

.product-table .product-row:nth-child(even) {
  background-color: var(--beige);
}

.product-table .product-row td {
  vertical-align: middle;
}

.product-table .product-row:hover {
  color: var(--brown);
}

.search-message {
  margin: auto;
  height: 100%;
  width: 100%;
  text-align: center;
}
</style>